export default {"src":"/_next/static/media/ToothDecayandCavities.5c3d003c.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};